

import Vue from "vue"
import ValidatedWorkerList from "../ValidatedWorkerList.vue"
import dateFormatMixin from '@/mixins/DateFormatMixin.vue'
import { VueConstructor } from "vue/types/umd"

interface PeriodData {
    id: number,
    started_at: string,
    finished_at: string
}

interface WorkerData {
    id: number,
    order_workers: OrderWorkerData[]
}

interface OrderWorkerData {
    period_id: number,
    status: number,
    contract_done: number,
    arrived_at: string,
    period: PeriodData
}

export default (Vue as VueConstructor<Vue & InstanceType<typeof dateFormatMixin>>).extend({
    name: 'OrderWorkerUpdateModal',
    components: {
      ValidatedWorkerList
    },
    props: {
        order: {
            type: Object,
        },
        orderPeriods: {
            type: Array as ()=> PeriodData[]
        },
        showModal: {
            type: Boolean,
            default: false
        },
        propertyToUpdate: {
            type: String,
            default: ''
        }
    },
    mixins: [
      dateFormatMixin
    ],
    data () {
        return {
            selectedCloseOrderState: null as string|null,
            workers: [] as WorkerData[],
            showOrderWorkerUpdateModal: false
        }
    },
    mounted() {
        this.showOrderWorkerUpdateModal = this.showModal
    },
    methods: {
        checkDisableButton() {
            let test: boolean[] = []
            if (this.workers.length > 0) {
                for(const worker of this.workers) {
                    for(const ow of worker.order_workers) {
                        test.push(Boolean(ow[this.propertyToUpdate as 'contract_done' | 'arrived_at']).valueOf())
                    }
                }
            }
            return !test.includes(false)
        },
        getOrderWorkers(workers: WorkerData[]) {
            this.workers = workers
        },
        updateAllOrderWorker() {
            for(const worker of this.workers) {
                for(const ow of worker.order_workers) {
                    if (!Boolean(ow[this.propertyToUpdate as 'contract_done' | 'arrived_at']).valueOf()) {
                        const startedAt = this.propertyToUpdate === 'arrived_at' ? ow.period.started_at : null;
                        (this.$refs[this.propertyToUpdate] as InstanceType<typeof ValidatedWorkerList>).updateOrderWorkerStatus(
                            worker.id,
                            ow.period_id,
                            ow.status,
                            this.propertyToUpdate as 'contract_done' | 'arrived_at',
                            false,
                            startedAt
                        )
                        this.$emit('updateOrderWorker')
                    }
                }
            }
            this.reload++
        },
        resetCloseOrder(){
            this.$emit('close')
        }
    }
})
